import {BaseModule} from "system/modules/BaseModule";

declare global
{
   interface Window
   {
      splashLoader :SplashLoaderInterface,
   }
}


export default class SplashLoader
   extends BaseModule
{

   onReady() {
      window.splashLoader = new SplashLoaderInterface();
   }
}

class SplashLoaderInterface
{
   private splashElement: Element;

   constructor() {
      let splash = document.body.querySelector('div.splash');

      if(!splash) {
         splash = document.createElement('div');
         splash.classList.add('splash');

         const splashIcon = document.createElement('div');
         splashIcon.classList.add('splash-icon');

         splash.appendChild(splashIcon);

         document.body.prepend(splash);
      }

      this.splashElement = splash;
   }

   public enable() {
      this.splashElement.classList.add('active');
      document.body.classList.add('disabledBody');
   }

   public disable() {
      this.splashElement.classList.remove('active');
      document.body.classList.remove('disabledBody');
   }
}